import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-task-type-dialog',
    templateUrl: './task-type-dialog.component.html',
    styleUrls: ['./task-type-dialog.component.css']
})
export class TaskTypeDialogComponent implements OnInit {


    task: string = '';
    storage = [];
    taskName = new FormControl();
    form = new FormGroup({
        name: new FormControl('', Validators.required),
    });

    constructor(public dialogRef: MatDialogRef<TaskTypeDialogComponent>,
                private taskSrvc: TaskService,
                private toastr: ToastrService
    ) {


    }

    ngOnInit(): void {
    }

    async save() {
        if (this.form.invalid) return;
        const response = await this.taskSrvc.addTaskType(this.task);
        if (response['type'] === 'success') {
            this.toastr.success('Uspješno dodata nova vrsta zadatka.')
            this.dialogRef.close({data: response['result']});
        } else {
            this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.')
        }
    }

    close() {
        this.dialogRef.close();
    }

}
